import React , {useState ,useEffect} from 'react'
import './style.css'

const Temp = () => {
    const [searchVal,setSearchVal]=useState("kolkata");
    const [temp , setTemp]=useState("");
    const getWeatherInfo = async()=>{
        try{
            let url = `https://api.openweathermap.org/data/2.5/weather?q=${searchVal}&units=metric&appid=244c7e871bc25af2484fc8181251b9f4`;
            const resp = await fetch(url);
            const data = await resp.json();
            const {temp ,humidity, pressure}=data.main;
            const {name}=data;
            const {speed}=data.wind;
            const {country , sunset}=data.sys;
            const { main: weathermood} = data.weather[0];
            const myNewWeatherInfo = {
               temp,
               humidity,
               pressure,
               weathermood,
               name,
               speed,
               country,
               sunset
            };
            console.log(weathermood);
            setTemp(myNewWeatherInfo);
        }  catch(error){
              console.log(error);
            }
    };
    const [weatherMood , setWeatherMood]=useState();
    useEffect(()=>{
        if(temp.weathermood){
            switch (temp.weathermood) {
                case "Clouds":
                    setWeatherMood('wi-day-cloudy');
                    break;
                case "Clear":
                    setWeatherMood('wi-day-sunny');
                    break;
                 case "Haze":
                    setWeatherMood('wi-day-fog');
                    break;
                case "Mist":
                    setWeatherMood('wi-dust');
                    break;
                default:
                    setWeatherMood('wi-day-sunny');
                    break;
            }
        }
    })
    let sec = temp.sunset;
    let date = new Date(sec*1000);
    let SunSetTime = `${date.getHours()}:${date.getMinutes()}`;
    useEffect(() => {getWeatherInfo();}, []); 

  return (
    <>
    <div className="wrap">
        <div className="search">
            <input type="search" className="searchTerm" placeholder='City Name ...' id="search" value ={searchVal} onChange={(val)=> setSearchVal(val.target.value)} autoFocus/>
            <button className="searchButton" type='button'onClick={getWeatherInfo}><i class="fa-solid fa-magnifying-glass"></i></button>
        </div>
    </div>
    {/* Temperature Card */}
    <article className='widget'>
       <div className="weatherIcon">
           <i className={"wi "+weatherMood}></i>
       </div>
       <div className="weatherInfo">
          <div className="temperature"><span>{temp.temp}&deg;</span></div> 
          <div className="description">
              <div className="weatherCondition">{temp.weathermood}</div>
              <div className="place">{temp.name} , {temp.country}</div>
          </div>
       </div>
       <div className="date">{new Date().toLocaleString()}</div>
       {/* Extra Info-s */}
       <div className="extra-temp">
           <div className="temp-info-minmax">
               <div className="two-sided-section">
                   <p><i className={"wi wi-sunset"}></i></p>
                   <p className="extra-info-leftside">{SunSetTime} PM<br/>SunSet</p>
               </div>
               <div className="two-sided-section">
                   <p><i className={"wi wi-humidity"}></i></p>
                   <p className="extra-info-leftside">{temp.humidity}%<br/>Humidity</p>
               </div>
           </div>
           <div className="weather-extra-info">
           <div className="two-sided-section">
                   <p><i className={"wi wi-windy"}></i></p>
                   <p className="extra-info-leftside">{temp.speed} m/s<br/>Wind</p>
               </div>
               <div className="two-sided-section">
                   <p><i className={"wi wi-barometer"}></i></p>
                   <p className="extra-info-leftside">{temp.pressure} hPa<br/>Pressure</p>
               </div>
           </div>
       </div>
    </article>
    </>
  )
}

export default Temp